module.exports = __webpack_public_path__ + "img/module0.6fbc6cb8.png";